export const getMainCanvasDOMElement = (): HTMLCanvasElement | undefined => {
  return globalThis.g_MainCanvas ?? undefined;
};

/**
 * MainCanvasDOMElement(SET)
 * @param targetMainCanvas 更新予定のメインキャンバス
 */
export const setMainCanvasDOMElement = (targetMainCanvas: HTMLCanvasElement) => {
  globalThis.g_MainCanvas = targetMainCanvas;
};
